import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTranslation } from "common/locales";

interface UpgradeNudgeDialogProps {
  open: boolean;
  onUpdate: () => void;
  onDismiss: () => void;
}

export default function UpgradeNudgeDialog({
  open,
  onUpdate,
  onDismiss,
}: UpgradeNudgeDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onDismiss}
      aria-labelledby="upgrade-nudge-title"
      aria-describedby="upgrade-nudge-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="upgrade-nudge-title">
        <Typography variant="h6" component="div">
          {t("softUpgrade.title")}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="upgrade-nudge-description">
          {t("softUpgrade.message")}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onDismiss} color="secondary" variant="text">
          {t("softUpgrade.dismissButton")}
        </Button>
        <Button onClick={onUpdate} color="primary" variant="contained">
          {t("softUpgrade.updateButton")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
